import { render, staticRenderFns } from "./ReplyEdit.vue?vue&type=template&id=7522b33a"
import script from "./ReplyEdit.vue?vue&type=script&lang=js"
export * from "./ReplyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports